<template>
  <div class="row">
    <div class="col-12">
      <PageHeader
        :page="page"
        :has-return="true"
        :has-add="isBeforeCutOffEgressDate"
        @onReturn="() => $router.push({ path: '/student' })"
        @onAdd="goToAddExit()"
      />
      <div class="row">
        <div class="col-12">
          <SectionTitle content="Egresos del estudiante" :has-line="true" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div v-for="item in rows" :key="item.id">
            <callout :has-toggle="true" class="mb-3 mt-1">
              <div class="row mt-2">
                <div
                  class="col-md-2 col-sm-12 border-right d-flex justify-content-center align-items-center"
                >
                  <div class="data-field-title">
                    {{ item.academicYear }}
                  </div>
                </div>
                <div class="col-md-2 col-sm-12 pl-4">
                  <div class="font-weight-normal font-14 color-gray--6">
                    Número:
                  </div>
                  <span class="font-weight-normal font-16 color-black--2">
                    {{ item.studentExitId }}
                  </span>
                </div>
                <div class="col-md-2 col-sm-12">
                  <div class="font-weight-normal font-14 color-gray--6">
                    Fecha:
                  </div>
                  <span class="font-weight-normal font-16 color-black--2">
                    {{ item.exitDate }}
                  </span>
                </div>
                <div class="col-md-2 col-sm-12">
                  <div class="font-weight-normal font-14 color-gray--6">
                    Fecha EDEN:
                  </div>
                  <span class="font-weight-normal font-16 color-black--2">
                    {{ item.edenReportedDate || '-' }}
                  </span>
                </div>
                <div class="col-md-2 col-sm-12">
                  <div class="font-weight-normal font-14 color-gray--6">
                    Razón:
                  </div>
                  <span class="font-weight-normal font-16 color-black--2">
                    {{ item.studentExitType }}
                  </span>
                </div>
                <div class="col-md-2 col-sm-12 text-right pr-5">
                  <div v-if="item.dropReason != ''">
                    <div class="font-weight-normal font-14 color-gray--6">
                      Acción:
                    </div>
                    <span class="font-weight-normal font-16 color-black--2">
                      Egreso - Eliminar Egreso
                    </span>
                  </div>
                  <div
                    v-if="
                      (canEdit(item) || canDeleteEgress(item)) &&
                        item.dropReason == ''
                    "
                    class="dropdown"
                  >
                    <button
                      id="ddAdiestramiento"
                      class="btn btn-dropdown-actions dropdown-toggle pt-1"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Acciones
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="ddAdiestramiento"
                    >
                      <a
                        v-if="canEdit(item)"
                        class="dropdown-item"
                        @click="goToAddExit(item.studentExitId)"
                      >
                        <i class="fas fa-pencil text-green" />
                        Editar
                      </a>
                      <a
                        v-if="canDeleteEgress(item)"
                        class="dropdown-item"
                        href="#"
                        @click="deleteEgress(item.academicYear, item.id)"
                      >
                        <i class="fas fa-times-circle text-red" />
                        Eliminar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <template #edition>
                <div class="bg-gray p-2">
                  <div class="bg-white rounded p-3">
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <em class="fas fa-info-circle text-orange mr-2" />
                        <span class="color-black--3 font-weight-bold font-16">
                          Información Adicional
                        </span>
                      </div>
                      <div class="col-md-12">
                        <div class="row ml-2">
                          <div class="col-md-4">
                            <div
                              class="font-weight-normal font-14 color-gray--6"
                            >
                              Región:
                            </div>
                            <span
                              class="font-weight-normal font-16 color-black--2"
                            >
                              {{ item.detail.regionName }}
                            </span>
                          </div>
                          <div class="col-md-4 pt-2">
                            <div
                              class="font-weight-normal font-14 color-gray--6"
                            >
                              Distrito:
                            </div>
                            <span
                              class="font-weight-normal font-16 color-black--2"
                            >
                              {{ item.detail.districtName }}
                            </span>
                          </div>
                          <div class="col-md-4 pt-2">
                            <div
                              class="font-weight-normal font-14 color-gray--6"
                            >
                              Escuela:
                            </div>
                            <span
                              class="font-weight-normal font-16 color-black--2"
                            >
                              {{ item.detail.schoolCode }} -
                              {{ item.detail.schoolName }}
                            </span>
                          </div>
                        </div>
                        <div class="row ml-2 mt-3">
                          <div class="col-md-4 pt-2">
                            <div
                              class="font-weight-normal font-14 color-gray--6"
                            >
                              Creación:
                            </div>
                            <span
                              class="font-weight-normal font-16 color-black--2"
                            >
                              {{ item.detail.createDate }} -
                              {{ item.detail.createDateTime }}
                              <br />
                              <i>{{ item.detail.createByFullName }}</i>
                            </span>
                          </div>
                          <div class="col-md-4 pt-2">
                            <div
                              class="font-weight-normal font-14 color-gray--6"
                            >
                              Modificación:
                            </div>
                            <span
                              class="font-weight-normal font-16 color-black--2"
                            >
                              {{ item.detail.modifyDate }} -
                              {{ item.detail.modifyDateTime }}
                              <br />
                              <i>{{ item.detail.modifyByFullName }}</i>
                            </span>
                          </div>
                          <div class="col-md-4 pt-2">
                            <div
                              class="font-weight-normal font-14 color-gray--6"
                            >
                              Comentario:
                            </div>
                            <span
                              class="font-weight-normal font-16 color-black--2"
                            >
                              {{ item.detail.comment }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </callout>
          </div>
          <div v-if="rows.length === 0" class="col-12 p-0">
            <div class="subheader-footer d-flex align-items-center rounded">
              <div class="row w-100">
                <div class="col-12 pt-0 ">
                  <i class="fal fa-folder-open icon" />
                  <span class="tsubhead-footer">
                    No hay Egresos registrados.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <customModal
            ref="popup"
            :message-box="{
              title: 'Alerta',
              messageCode: '0547',
              size: 'modal-lg',
              message: message.areYouSureToDelete,
              type: 'confirm',
              icon: 'fa fa-exclamation',
            }"
            :success-callback="deleteEgress"
            :cancel-callback="onCloseModal"
          />

          <customPager
            ref="historyPager"
            :per-page="tableConfig.serverParams.perPage"
            :total="tableConfig.totalRecords"
            :page-changed="onPageChange"
            :per-page-changed="onPerPageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import moment from 'moment';
import { SectionTitle } from '@/components/pei/shared';
import customModal from '@/components/common/modal/custommodal';
import alert from '@/mixin/alert.mixin';
import PageHeader from '@/components/common/page/PageHeader';
import Callout from '@/components/common/callout/View.vue';
import commentTypes from '@/utils/constants/comment/commentTypes';
import codeViewTypes from '@/utils/constants/comment/CodeViewTypes.js';
import resourcesService from '@/services/resources.js';
import StudentStatuses from '@/utils/constants/reg/studentStatuses.js';
const DropReasons = {
  ExitDropExit: 1,
};
export default {
  name: 'HistoryEgress',
  mixins: [alert],
  components: {
    SectionTitle,
    PageHeader,
    customModal,
    Callout,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Egreso: Historial del Estudiante',
        routes: ['Inicio', 'Estudiante', 'Egreso', 'Egreso: Historial Egreso'],
      },
      rows: [],
      message: {
        errorOnSaving: 'Se ha producido un error al guardar el documento',
        errorToFetch: 'Ha ocurrido un error al consultar los datos.',
        errorToDownload: 'Ha ocurrido un error al descargar la descarga.',
        successOnDelete: 'Documento fue eliminado exitosamente.',
        areYouSureToDelete: '¿Está seguro que desea eliminar el documento?',
        empty: '',
        missingFields: 'Se requiere completar todos los campos para continuar.',
        notAllowedToDelete: 'No puedes eliminar este documento; es requerido.',
        notDuplicatedTypeAllowed:
          'Ya el formulario cuenta con el documento de tipo {0}',
      },
      tableConfig: {
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: '',
            type: '',
          },
          page: 1,
          perPage: 10,
        },
      },
      currentYear: null,
      isBeforeCutOffEgressDate: true, //Se deja hardcoded ya que se quito el uso del parámetro EDENExitingEndDate, por lo que se deja preparada la logica por si se requiere nuevamente a condicionar
    };
  },
  computed: {
    isStudenElegible() {
      let studentStatus = this.$store.state.$_student.selectedStudent.status;
      if (studentStatus != null) {
        switch (studentStatus) {
          case StudentStatuses.Servido:
            return true;
          case StudentStatuses.Elegible:
            return true;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    onCloseModal() {
      this.cancel();
    },
    async deleteEgress(academicYear, exitId) {
      const { data } = await this.$ApiGet(
        `/api/student/ValidateDeterminationByEgress/${exitId}`
      );

      if (data) {
        this.ShowToast('Alerta', this.resources['R02210001'], 'warning');
      } else {
        await alert.methods
          .ShowCancelModal(
            'Atención',
            '¿Está seguro que desea eliminar este registro de egreso?',
            'Sí',
            'No'
          )
          .then((answer) => {
            if (answer) {
              let exit = {
                exitId: exitId,
                date: new Date(),
                saved: false,
                pathName: 'Egress',
              };

              store.dispatch('setExit', exit);
              this.$router.push({
                name: 'studentAddComment',
                params: {
                  isReadOnly: true,
                  commentId: null,
                  commentDate: new Date(),
                  academicYearId: academicYear,
                  commentCategoryTypeId: commentTypes.EgresoEliminarEgreso,
                  codeViewTypeId: codeViewTypes.EgresarEstudiante,
                },
              });
            }
          });
      }
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R02210001',
      ]);
    },
    loadCurrentYear() {
      this.$ApiGet(`api/academicyears/current`).then((response) => {
        this.currentYear = response.data;
      });
    },
    formatDate(date) {
      if (date == null) return '';

      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    formatTime(date) {
      if (date == null) return '';

      return moment(date)
        .locale('es')
        .format('hh:mm:ss a');
    },
    getHistory() {
      this.$ApiGet(
        '/api/student/egresshistory?studentSieId=' +
          store.getters['$_student/StudentSie']
      )
        .then((res) => {
          this.rows = res.data.data ? this.formatData(res.data.data) : [];
          this.tableConfig.totalPages = res.data.pageCount;
          this.tableConfig.totalRecords = res.data.totalItemCount;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    formatData(data) {
      const rows = [];

      data.forEach((element) => {
        const row = {
          children: [],
          id: element.studentExitId,
          academicYear: element.academicYear,
          studentExitId: element.studentExitId,
          edenReportedDate: element.edenReportedDate
            ? this.formatDate(element.edenReportedDate)
            : element.edenReportedDate,
          exitDate: this.formatDate(element.exitDate),
          exitDateFull: element.exitDate,
          studentExitType: element.studentExitType,
          detail: {
            schoolName: element.schoolName,
            regionName: element.regionName,
            districtName: element.districtName,
            createByFullName: element.createByFullName,
            createDate: this.formatDate(element.createDate),
            createDateTime: this.formatTime(element.createDate),
            modifyByFullName: element.modifyByFullName,
            modifyDate: this.formatDate(element.modifyDate),
            modifyDateTime: this.formatTime(element.modifyDate),
            comment: element.comment,
            schoolCode: element.schoolCode,
          },
          dropReason: element.dropReason,
        };
        rows.push(row);
      });
      return rows;
    },
    //ECG:Table methods
    updateParams(newProps) {
      this.tableConfig.serverParams = Object.assign(
        {},
        this.tableConfig.serverParams,
        newProps
      );
    },
    canEdit(item) {
      const today = moment(new Date());
      const egressDate = moment(item.exitDateFull);
      return (
        (this.isBeforeCutOffEgressDate &&
          today.diff(egressDate, 'years') <= 2) ||
        item.edenReportedDate === null
      );
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getHistory();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.getHistory();
    },
    goToAddExit(egresoId) {
      let url = egresoId ? '?id=' + egresoId : '';

      if (!egresoId && !this.isStudenElegible) {
        this.ShowToast(
          'Alerta',
          'Para poder realizar Egreso en sistema el estatus del estudiante debe ser Servido o Elegible . ',
          'error'
        );
      } else {
        this.$router.push('/student/egress/addeditegress' + url);
      }
    },
    deleteEgressPermission() {
      return store.getters.HasPermission('students.egress.delete');
    },
    canDeleteEgress(item) {
      const isCurrentYear = this.currentYear.description === item.academicYear;
      const canDeleteEdenReported = store.getters.HasPermission(
        'students.egress.edenreported.delete'
      );
      const canDeletePreviousYearsEgress = store.getters.HasPermission(
        'students.egress.previousyears.delete'
      );
      return (
        (this.isBeforeCutOffEgressDate && canDeleteEdenReported) ||
        (isCurrentYear && canDeletePreviousYearsEgress) ||
        (canDeleteEdenReported && item.edenReportedDate == null)
      );
    },
    deleteExit(exit) {
      this.$ApiDelete(
        `/api/student/${store.getters['$_student/StudentSie']}/egress/${exit.exitId}?dropreason=${DropReasons.ExitDropExit}`
      ).then((response) => {
        if (response.data) {
          this.ShowToast(
            'Proceso exitoso.',
            'Egreso eliminado satisfactoriamente.',
            'success'
          );

          store.dispatch('$_student/refreshStudentMainInfo');
          store.dispatch('setExit', null);

          this.getHistory();
        }
      });
    },
    init() {
      const exit = store.getters.getExit;
      if (exit && exit.saved) {
        this.deleteExit(exit);
      }
    },
  },
  async created() {
    Promise.all([
      this.loadResources(),
      this.loadCurrentYear(),
      this.getHistory(),
      this.init(),
    ]);
  },
};
</script>

<style scoped>
.accordion {
  background-color: #fafbfa;
}

.accordion >>> hr {
  margin-left: 45px;
  margin-right: 45px;
  border: 1px solid #dadada;
}

.accordion >>> .card-header {
  border-bottom-color: #fafbfa;
}
.accordion >>> .accordion-header[aria-expanded='false'] {
  background-color: #fafbfa;
}

.accordion >>> .accordion-header[aria-expanded='true'] {
  background-color: #fafbfa;
}

.header {
  height: 54px;
  padding-left: 20px;
  background: #3f5b60 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.subheader {
  height: 54px;
  padding-left: 20px;
  background: #e7ebe9 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
}

.thead-property {
  color: #ffffff;
}

.tsubhead-property {
  color: #11291b;
  font-weight: bold;
  font-size: 20px;
}

.subheader-footer {
  height: unset !important;
  padding-left: 20px;
  background: #fafbfa 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  padding: 10px 10px;
}

.subheader-footer .icon {
  font-size: 35px;
  height: 60px;
  width: 60px;
  border: unset !important;
  border-radius: 127px;
  padding-top: 10px;
  padding-left: 3px;
  color: #e2e2e2;
}

.tsubhead-footer {
  color: #e2e2e2;
  font-weight: bold;
  font-size: 14px;
  padding-left: 15px;
  padding-bottom: 13px;
  vertical-align: super;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.text-fix {
  font-weight: 400;
}

.data-field-title {
  color: #11291b;
  font-weight: bold;
  font-size: 16px;
}
</style>
